const mutations = {

}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/news/mutations/index.js